// @mui
import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Image from 'src/components/NextSanityImage';

// ----------------------------------------------------------------------

const SUMMARY = [
  { name: 'Omsetning', number: 80000000 },
  // { name: 'Kunder', number: 200000 },
  // { name: 'Partnere', number: 150 },
  { name: 'Ansatte', number: 40 },
];

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(8, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(10, 0),
  },
}));

const SectionStyle = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  position: 'relative',
  borderRadius: Number(theme.shape.borderRadius) * 2,
}));

// ----------------------------------------------------------------------

export default function About() {
  return (
    <RootStyle>
      <Container>
        <Typography
          paragraph
          variant="overline"
          sx={{ color: 'primary.main', textAlign: { xs: 'center', md: 'left' } }}
        >
          Om oss
        </Typography>

        <Grid
          container
          spacing={{ xs: 5, md: 3 }}
          justifyContent="space-between"
          sx={{
            mb: { xs: 8, md: 10 },
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <Grid item xs={12} md={6} lg={5}>
            <Typography variant="h2">En ledende elektriker i Bergen.</Typography>
          </Grid>

          <Grid item xs={12} md={6} lg={6} sx={{ color: 'text.secondary' }}>
            <Stack spacing={{ xs: 3, md: 10 }} direction={{ xs: 'column', md: 'row' }}>
              <Typography>
                BEA har siden oppstarten i 2000 utviklet seg til å bli en ledende elektrobedrift i Bergen og omegn. BEA består i dag av 45 hyggelige medarbeidere og forventer en omsetning i 2022 på rundt 80 millioner.
              </Typography>
              <Typography>
                Vårt hovedfokus er kontinuerlig utvikling av moderne og effektive løsninger basert på behovene og ønskene til våre oppdragsgivere.
              </Typography>
            </Stack>
          </Grid>
        </Grid>

        <Section />
      </Container>
    </RootStyle>
  );
}

// ----------------------------------------------------------------------

function Section() {
  return (
    <SectionStyle>
      <Stack
        sx={{
          py: { xs: 10, md: 25 },
          zIndex: 9,
          ml: 'auto',
          position: 'relative',
          px: { xs: 2.5, md: 10 },
          width: { md: 0.75, lg: 0.5 },
        }}
      >
        <Stack
          sx={{
            mb: 5,
            color: 'common.white',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          {/* <Typography variant="h2" paragraph>
            En del av BEA Gruppen
          </Typography>
          <Typography sx={{ opacity: 0.72 }}>
            BEA Gruppen består av Bergen Elektro Automasjon AS og BEA Lyd & Bilde AS. Vi har også en
            egen avdeling for Offshore - BEA Offshore.
          </Typography> */}
        </Stack>

        {/* <Box
          sx={{
            display: 'grid',
            gap: 5,
            gridTemplateColumns: 'repeat(2, 1fr)',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          {SUMMARY.map((value) => (
            <div key={value.name}>
              <Typography variant="h2" gutterBottom sx={{ color: 'primary.main' }}>
                <CountUpNumber
                  start={value.number / 5}
                  end={value.number}
                  formattingFn={(value: number) => fShortenNumber(value)}
                />
                <Typography variant="h3" component="span" sx={{ verticalAlign: 'top', ml: 0.5 }}>
                  +
                </Typography>
              </Typography>

              <Typography variant="body2" sx={{ color: 'grey.500' }}>
                {value.name}
              </Typography>
            </div>
          ))}
        </Box> */}
      </Stack>

      {/* <BgOverlay
        sx={{
          opacity: 0.8,
          right: { md: 0 },
          left: { md: 'auto' },
          width: { md: 0.75, lg: 1 },
          borderRadius: (theme) => Number(theme.shape.borderRadius) * 2 + "px",
        }}
      /> */}

      <Box sx={{ position: 'absolute', width: 1, height: 1, top: 0 }}>
        <Image
          alt="about"
          src="image-4210ac8f6dda085e822fca683bb776b4c599314f-3840x2560-jpg"
          sx={{ width: 1, height: 1 }}
        />
      </Box>
    </SectionStyle>
  );
}
